:host {
  font-family: var(--ai12z-bot-font-family) !important;
  font-size: var(--ai12z-bot-font-size) !important;
}
.popover-content {
  position: fixed;
  bottom: 10%;
  right: 70px;
  background-color: #fff;
  /* border: 1px solid #ccc; */
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 200px;
}

.popover-content:after {
  bottom: 12px;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border: 10px solid hsla(0, 0%, 100%, 0);
  right: -20px;
  border-color: transparent transparent transparent #fff;
  /* border-color: transparent transparent #fff transparent;  */
  /* border-left-color: #fff; */
}
.popover-content > span {
  overflow-y: auto;
  overflow-x: hidden;
  text-align: left;
  text-align: initial;
  /* padding: 10px; */
  border: 2px solid transparent;
  margin: 0;
  max-height: 96px;
  max-width: 220px;
  line-height: 20px;
  font-size: 14px;
  display: block;
  color: #212021;
  cursor: pointer;
}

/* Close button styling */
.popover-close {
  position: absolute;
  top: 1px;
  right: 1px;
  /* background-color: transparent; */
  border: none;
  cursor: pointer;
  font-size: 9px;
  color: black;
  /* font-weight: bold; */
  /* background-color: grey; */
  border-radius: 50%;
}

/* .popover-close:hover {
  background-color: grey;
  border-radius: 50%;
} */
